import { Breadcrumb } from "../../store/reducers";
import { ACCOUNT_SETTINGS, ALL, DOCUMENT_DELIVERY, TRACKED_DOCUMENTS_LIST, USER_PANEL } from "./breadcrumb-link-code.constants";

export const PRODUCT_FIRST_LEVEL_PATHS: Breadcrumb[] = [
    { label: 'Home', link: '/', isToTranslate: true },
    { label: 'Products', link: '/webshop', isToTranslate: true }
];

export const MY_ORDERS_PATHS: Breadcrumb[] = [
    { label: 'Home', link: '/', isToTranslate: true },
    { label: 'My orders', link: '', isToTranslate: true }
];

export const MY_BACK_ORDERS_PATHS: Breadcrumb[] = [
    { label: 'Home', link: '/', isToTranslate: true },
    { label: 'My back orders', link: '', isToTranslate: true }
];

export const MY_INVOICES_PATHS: Breadcrumb[] = [
    { label: 'Home', link: '/', isToTranslate: true },
    { label: 'My invoices', link: '', isToTranslate: true }
];

export const MY_OFFERS_PATHS: Breadcrumb[] = [
    { label: 'Home', link: '/', isToTranslate: true },
    { label: 'My offers', link: '', isToTranslate: true }
];

export const MY_BUILDING_SITES_PATHS: Breadcrumb[] = [
    { label: 'Home', link: '/', isToTranslate: true },
    { label: 'Building sites', link: '', isToTranslate: true }
];

export const MY_BUILDING_SITES_FORM_PATHS: Breadcrumb[] = [
    { label: 'Home', link: '/', isToTranslate: true },
    { label: 'Building sites', link: 'Cart/BuildingSites/List', isToTranslate: true },
    { label: 'New building site', link: 'Cart/BuildingSites/List', isToTranslate: true }
];

export const PRODUCT_SECOND_LEVEL_PATHS: Breadcrumb[] = [
    { label: 'HOME', link: '/', isToTranslate: true },
    { label: 'PRODUCTS', link: '/webshop', isToTranslate: true },
    { label: '', link: '', isToTranslate: false },
];

export const PRODUCT_THIRD_LEVEL_PATHS: Breadcrumb[] = [
    { label: 'HOME', link: '/', isToTranslate: true },
    { label: 'PRODUCTS', link: '/webshop', isToTranslate: true },
    { label: '', link: '', isToTranslate: false },
    { label: '', link: '', isToTranslate: false },
];

export const SHOPPING_CART_PATHS: Breadcrumb[] = [
    { label: 'HOME', link: '/', isToTranslate: true },
    { label: 'SHOPPING_CART', link: '/Cart', isToTranslate: true }
];

export const ORDER_PATHS: Breadcrumb[] = [
    { label: 'Order', link: '/Order/OrderConfirmation', isToTranslate: true },
    { label: 'ORDER_CONFIRM', link: '/Order/OrderSuccess', isToTranslate: true }
];

export const FAVORITE_PRODUCTS_PATHS: Breadcrumb[] = [
    { label: 'FAVORITE_PRODUCTS', link: '/FavoriteProducts', isToTranslate: true },
];

export const FORGOTTEN_PASSWORD_PATHS: Breadcrumb[] = [
    { label: '', link: '/send-email-to-reset-password', isToTranslate: true },
];

export const ACCOUNT_PATHS: Breadcrumb[] = [
    { label: 'CREATE_NEW_ACCOUNT', link: '/register', isToTranslate: true },
];

export const DOCUMENTS_DELIVERY: Breadcrumb[] = [
    { link: `/${DOCUMENT_DELIVERY}` } as Breadcrumb,
    { link: `/${DOCUMENT_DELIVERY}/${TRACKED_DOCUMENTS_LIST}` } as Breadcrumb,
    { link: `/${DOCUMENT_DELIVERY}/${TRACKED_DOCUMENTS_LIST}/${ALL}` }  as Breadcrumb,
];

export const USER_PANEL_PATHS: Breadcrumb[] = [
    { link: `/${USER_PANEL}` } as Breadcrumb,
    { link: `${USER_PANEL}/${ACCOUNT_SETTINGS}` } as Breadcrumb,
    { link: `${USER_PANEL}/${ACCOUNT_SETTINGS}#CompanyData` } as Breadcrumb,
    { link: `${USER_PANEL}/${ACCOUNT_SETTINGS}#PersonalData` } as Breadcrumb
];

export const BUILDING_SITES_PATHS: Breadcrumb[] = [
    { label: 'BUILDING_SITES', link: '/BuildingSite/List', isToTranslate: true },
];